import { BarChartOutlined, CheckSquareOutlined, AlertOutlined } from '@ant-design/icons';

const elections = {
  id: 'group-elections',
  title: 'Elections',
  type: 'group',
  children: [
    {
      id: 'tally-results',
      title: 'Live Tallying Center',
      type: 'item',
      url: '/elections/tally-results',
      icon: CheckSquareOutlined
    },
    {
      id: 'reported-incidents',
      title: 'Reported Incidents',
      type: 'item',
      url: '/elections/reported-incidents',
      icon: AlertOutlined
    }
  ]
};

export default elections;
